import { AuthContext } from '../context/authContext'
import { useContext } from 'react'


// Returns the context and makes sure we are using it within the correct scope 
export const useAuthContext = () => {
    const context = useContext(AuthContext)

    if (!context) {
        throw Error('useAuthContext must be used inside an AuthContextProvider')
    }

    return context;
}